/**
 * 根据节点ID找出指定节点
 * @param {Array} data 树状结构数据
 * @param {String} id 节点ID
 * @returns 返回指定节点
 */
export function findNodeById(data, id) {
    for (const node of data) {
        if (node.nodeId === id) return node;
        if (node.subNodes && node.subNodes.length) {
            const res = this.findNodeById(node.subNodes, id);
            if (res) return res;
        }
    }
    return null;
}

/**
 * 找出指定节点的所有父节点(包括节点本身)
 * @param {Node} node 指定节点
 * @param {Array} array 存放父节点的数组
 */
export function getParentNode(node, array) {
    if (node.parent) {
        array.push(node);
        this.getParentNode(node.parent, array);
    }
}

/**
 * 格式化时间
 * @param {String} utcTime UTC时间字符串
 * @returns 格式化后的时间字符串
 */
export function formatTime(utcTime) {
    if (!utcTime) return;
    let date = new Date(Date.parse(utcTime));
    let year = date.getFullYear();
    let month = pad2(date.getMonth() + 1);
    let day = pad2(date.getDate());
    let hour = pad2(date.getHours());
    let minute = pad2(date.getMinutes());
    let second = pad2(date.getSeconds());
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

/**
 * 格式化时间（年-月-日）
 * @param {String} utcTime UTC时间字符串
 * @returns 格式化后的时间字符串
 */
export function formatTime_YMD(utcTime) {
    if (!utcTime) return;
    let date = new Date(Date.parse(utcTime));
    let year = date.getFullYear();
    let month = pad2(date.getMonth() + 1);
    let day = pad2(date.getDate());
    return `${year}-${month}-${day}`;
}

function pad2(n) {
    return n < 10 ? '0' + n : n;
}

/**
 *
 * @param {Number} length 文件大小
 * @returns 格式化后的文件大小字符串
 */
export function formatFileSize(length) {
    let fileSize = '--';

    if (length) {
        length = length / 1024;
    } else {
        return { fileSize, unit: '' };
    }

    if (parseInt(length) > 1024) {
        length = length / 1024;
    } else {
        fileSize = length.toFixed(2);
        return { fileSize, unit: 'KB' };
    }

    if (parseInt(length) > 1024) {
        length = length / 1024;
    } else {
        fileSize = length.toFixed(2);
        return { fileSize, unit: 'MB' };
    }

    if (parseInt(length) > 1024) {
        fileSize = (length / 1024).toFixed(2);
        return { fileSize, unit: 'TB' };
    } else {
        fileSize = length.toFixed(2);
        return { fileSize, unit: 'GB' };
    }
}

export function formatSecond(second) {
    let timeString = '';
    let d = parseInt(second / 60 / 60 / 24);
    if (d) {
        timeString += `${d}天`;
    }
    let h = parseInt((second / 60 / 60) % 24);
    if (h) {
        h = h < 10 ? '0' + h : h;
        timeString += `${h}小时`;
    }
    let m = parseInt((second / 60) % 60);
    if (m) {
        m = m < 10 ? '0' + m : m;
        timeString += `${m}分钟`;
    }
    let s = parseInt(second % 60);
    if (s) {
        s = s < 10 ? '0' + s : s;
        timeString += `${s}秒`;
    }
    if (!timeString) {
        timeString = '--';
    }
    return timeString;
}

/**
 * 比较时间的先后
 * @param {String} timeStr_1 时间字符串数据
 * @param {String} timeStr_2 时间字符串数据
 * @returns timeStr_1 在 timeStr_2 的前后  0：相同 1：在前 2：在后
 */
export function compareTime(timeStr_1, timeStr_2) {
    const time_1 = new Date(timeStr_1);
    const time_2 = new Date(timeStr_2);

    if (time_1 > time_2) {
        return 2;
    } else if (time_1 < time_2) {
        return 1;
    } else {
        return 0;
    }
}

/**
 * 格式化进度
 * @param {Number} progress
 * @returns 格式化后的字符串
 */
export function formatText(progress) {
    let string = '';
    if (formatRatio(progress) !== 100) {
        string = `${formatRatio(progress)}%`;
    }
    return string;
}

export function formatRatio(progress) {
    return progress / 100;
}

/**
 * 返回token
 * @returns token
 */
export function getToken() {
    return sessionStorage.getItem('token');
}

/**
 * 返回tokenId
 * @returns tokenId
 */
export function getTokenId() {
    return sessionStorage.getItem('tokenId');
}

/**
 * 压缩图片到指定大小
 * @param baseImg base64图片
 * @param maxSize 单位kb
 */
export function compressImgBySize(baseImg, maxSize = 200) {
    return new Promise((resolve) => {
        const strLength = baseImg.length;
        const fileLength = parseInt(strLength - (strLength / 8) * 2);
        let size = parseInt((fileLength / 1024).toFixed(2));

        if (size <= maxSize) {
            let blobFile = dataURLtoFile(baseImg, 'image/jpeg');
            resolve(blobFile);
            return;
        }

        const img = new Image();
        // img.src = 'data:image/jpeg;base64,' + baseImg
        img.src = baseImg;
        img.onload = () => {
            const canvas = imgToCanvas(img);
            let resUrl = '';
            let quality = 0.9;
            while (size > maxSize && quality > 0) {
                resUrl = canvas.toDataURL('image/jpeg', quality);
                const resLength = resUrl.length;
                const resFileLength = parseInt(resLength - (resLength / 8) * 2);
                size = parseInt((resFileLength / 1024).toFixed(2));
                quality = Number((quality - 0.1).toFixed(1));
            }
            let blobFile = dataURLtoFile(resUrl, 'image/jpeg');
            resolve(blobFile);
        };
        img.onerror = () => {
            resolve(baseImg);
        };
    });
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader(); //定义方法读取文件
        reader.readAsDataURL(file); //开始读文件  本身是图片的二进制数据 进行base64加密形成字符串
        reader.onload = () => resolve(reader.result); //成功返回对应的值 reader.result可以直接放在img标签中使用
        reader.onerror = (error) => reject(error); //失败返回失败信息
    });
}

// 把image 转换为 canvas对象
export function imgToCanvas(image) {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext('2d').drawImage(image, 0, 0);
    return canvas;
}

// 将base64转换为blob
function dataURLtoFile(dataURI, type) {
    let binary = atob(dataURI.split(',')[1]);
    let array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
}

/**
 * 关闭浏览器标签页(兼容浏览器)
 */
export function exitSystem() {
    if (navigator.userAgent.indexOf('MSIE') > 0) {
        if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
            //适用于ie6不带提示关闭窗口
            window.opener = null;
            window.close();
        } else {
            window.open('', '_top'); //ie7之后不提示关闭窗口
            window.top.close();
        }
    } else if (navigator.userAgent.indexOf('Firefox') > 0) {
        //Firefox不提示关闭窗口
        window.location.href = 'about:blank ';
    } else {
        window.opener = null;
        window.open('', '_self', ''); //其他浏览器
        window.close();
    }
}

export function encryptPassword(password) {
    if (!window.isEncryptPassword) return password;
    if (window.isEncryptPassword) {
        return btoa(password);
    }
}

/**
 * 生成Guid
 * @returns
 */

export function guid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}
